module.exports = __webpack_public_path__ + "static/media/profile-menu.6ce4f229.png";